<template>
    <div class="header-nav">
        <!-- logo -->
        <router-link class="header-nav__logo" to="/home">
            <!-- <img class="icon-logo" src="../../assets/images/logo-icon.png" alt=""> -->
            <img class="text-logo" tag="div" src="../../assets/images/tob-design-logo.svg" alt="" />
            <!-- <router-link class="icon-logo" tag="div" to="/home"></router-link> -->
        </router-link>
        <!-- 导航 -->
        <nav class="header-nav__navigation">
            <ul class="header-nav__navigation-list">
                <li tag="li" to="/home" :class="{ active: $route.name === 'Home' }" @click="clearSearchCache('/home')">
                    <span>主页</span>
                </li>
                <el-dropdown @visible-change="(visible) => (discoverVisible = visible)" placement="bottom">
                    <li tag="li">
                        <span
                            :class="{
                                notice: tipList.includes('DESIGN_WORKS') || tipList.includes('EXPERIENCE') || tipList.includes('RESOURCES'),
                            }"
                            >发现</span
                        >
                        <el-dropdown-menu class="dropdown-menu" slot="dropdown" @click="discoverVisible = false">
                            <el-dropdown-item class="self-item">
                                <li
                                    tag="li"
                                    class="list-menu"
                                    to="/works"
                                    :class="{ active: $route.name === 'Works' }"
                                    @click="clearSearchCache('/works', 'DESIGN_WORKS')"
                                >
                                    <span :class="{ notice: tipList.includes('DESIGN_WORKS') }">设计作品</span>
                                </li>
                            </el-dropdown-item>
                            <el-dropdown-item class="self-item">
                                <li
                                    tag="li"
                                    class="list-menu"
                                    to="/experience"
                                    :class="{ active: $route.name === 'Experience' }"
                                    @click="clearSearchCache('/experience', 'EXPERIENCE')"
                                >
                                    <span :class="{ notice: tipList.includes('EXPERIENCE') }">设计经验</span>
                                </li>
                            </el-dropdown-item>
                            <el-dropdown-item class="self-item">
                                <li
                                    tag="li"
                                    class="list-menu"
                                    to="/tool"
                                    :class="{ active: $route.name === 'Tool' }"
                                    @click="clearSearchCache('/tool', 'RESOURCES')"
                                >
                                    <span :class="{ notice: tipList.includes('RESOURCES') }">工具资源</span>
                                </li>
                            </el-dropdown-item>
                            <!-- <el-dropdown-item class="self-item">
                                <li
                                    tag="li"
                                    class="list-menu"
                                    to="/courses"
                                    :class="{ active: $route.name === 'Courses' }"
                                    @click="clearSearchCache('/courses', 'COURSE')"
                                >
                                    <span :class="{ notice: tipList.includes('COURSE') }">实用课程</span>
                                </li>
                            </el-dropdown-item> -->
                        </el-dropdown-menu>
                    </li>
                </el-dropdown>
                <li
                    tag="li"
                    to="/projectCase"
                    :class="{ active: $route.name === 'ProjectCase' }"
                    @click="openProjectCase"
                >
                    <span style="position: relative" :class="{ notice: tipList.includes('BUSINESS_PROJECT') }">找案例</span>
                    <!-- <svg-icon icon-class="new" class-name="icon-new"></svg-icon> -->
                </li>
                <li
                    tag="li"
                    to="/material"
                    :class="{ active: $route.name === 'FreeMaterial', material: true }"
                    @click="clearSearchCache('/material', 'MATERIAL')"
                >
                    <span :class="{ notice: tipList.includes('MATERIAL') }">找素材</span>
                </li>
                <!-- <li tag="li" to="/findImage" 
                    :class="{ active: $route.name === 'FindImage' }" @click="clearSearchCache('/findImage','IMAGE_MATERIAL')">
                    <span :class="{ notice: tipList.includes('IMAGE_MATERIAL') }">找图片</span>
                </li> -->
                <li
                    tag="li"
                    to="/sourceCode"
                    :class="{ active: $route.name === 'SourceCode' }"
                    @click="clearSearchCache('/sourceCode', 'SOURCE_CODE')"
                >
                    <span style="position: relative" :class="{ notice: tipList.includes('SOURCE_CODE') }">找源码</span>
                    <!-- <svg-icon icon-class="new" class-name="icon-new"></svg-icon> -->
                </li>
                <!-- <li tag="li" to="/courses" :class="{'active': $route.name === 'Courses'}" @click="clearSearchCache('/courses','COURSE')">
                    <span :class="{'notice': tipList.includes('COURSE')}">课程</span>
                </li> -->

                <!-- <li tag="li" to="/forum" @click="clearSearchCache('/forum')">
                    <span>社区</span>
                </li> -->
            </ul>
        </nav>
        <!-- 操作栏 -->
        <div class="header-nav__auth">
            <div class="header-nav__auth-search expanded-search">
                <el-autocomplete
                    ref="searchInput"
                    class="search-input"
                    :class="{'search-active':search}"
                    v-model="search"
                    :fetch-suggestions="querySearch"
                    @keyup.native.enter="handleSearch"
                    @select="handleSearch"
                    placeholder="请输入关键词"
                >
                    <template slot="suffix">
                        <i 
                            v-if="search" 
                            class="el-icon-close clear-icon" 
                            @click="clearSearch"
                        ></i>
                        <i
                            class="el-input__icon el-icon-search search-btn-icon"
                            @click="handleSearch"
                        ></i>
                    </template>
                    <template slot-scope="{ item }">
                        <div>{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </div>
            <div class="header-nav__auth-item" :class="{ active: uploadVisible }" v-if="userInfo">
                <el-dropdown @visible-change="(visible) => (uploadVisible = visible)" placement="bottom">
                    <a class="el-dropdown-link">
                        <svg-icon icon-class="send" class-name="icon-send"></svg-icon>
                    </a>
                    <el-dropdown-menu class="dropdown-menu upload-dropdown" slot="dropdown" @click="uploadVisible = false">
                        <el-dropdown-item>
                            <router-link target="_blank" to="/upload/works">上传作品</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <router-link target="_blank" to="/upload/experience">上传经验</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <router-link target="_blank" to="/upload/material">素材投稿</router-link>
                        </el-dropdown-item>
                        <!-- <el-dropdown-item v-if="userInfo.projectPriv">
                            <router-link target="_blank" to="/upload/case">上传案例</router-link>
                        </el-dropdown-item> -->
                        <!-- <el-dropdown-item v-for="(item, index) in topicTypes" 
                            :key="index" 
                            :class="`publishType${index}`" >
                            <router-link target="_blank" :to="{name: 'ForumPublish', params: { type: index + 1}}">{{item}}</router-link>
                        </el-dropdown-item> -->
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="header-nav__auth-item" :class="{ active: noticeVisible }" v-if="userInfo">
                <el-dropdown @visible-change="handleNoticeDropdown" placement="bottom">
                    <a class="el-dropdown-link">
                        <el-badge :is-dot="hasNewMessage" class="item">
                            <svg-icon icon-class="message" class-name="icon-message"></svg-icon>
                        </el-badge>
                    </a>
                    <el-dropdown-menu class="notice-wrapper" slot="dropdown" @click="noticeVisible = false">
                        <div class="notice-wrapper__title">消息盒</div>
                        <EmptyPage size="small" :height="200" text="暂无消息" :loading="noticeLoading" v-if="noticeList.length === 0" />
                        <div class="notice-wrapper__list" v-else>
                            <router-link class="notice-wrapper__list-item" v-for="(notice, index) in noticeList" :key="index" tag="div" to="/message">
                                <svg-icon :icon-class="'noticeIcon' + notice.noticetype" class-name="icon-noticeIcon"></svg-icon>
                                {{ notice.name }}
                                {{ notice.content }}
                            </router-link>
                        </div>
                        <router-link class="notice-wrapper__bottom" tag="div" to="/message">
                            <span style="cursor: pointer">查看全部</span>
                        </router-link>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="header-nav__auth-item" :class="{ active: userVisible }" v-if="userInfo">
                <el-dropdown @visible-change="(visible) => (userVisible = visible)" @command="handleCommand" placement="bottom">
                    <a class="el-dropdown-link">
                        <div class="icon-user">
                            <img class="icon-user-image" :src="userInfo.imageAddress || avatarUrl" />
                            <div class="icon-user-vip" v-if="userInfo.state === 2">
                                <svg-icon icon-class="avatar_vip" class-name="icon-avatar_vip"></svg-icon>
                            </div>
                            <div class="icon-user-vip" v-else-if="userInfo.state === 3">
                                <img :src="require('@/assets/images/seed.png')" width="16" />
                            </div>
                        </div>
                    </a>
                    <el-dropdown-menu class="dropdown-menu" slot="dropdown" @click="userVisible = false">
                        <!-- <el-dropdown-item command="imageVip" class="list-menu vip-menu" v-if="userInfo.memberExpire != 0">
                            <div class="vip-level" v-if="userInfo.memberExpire == 1">
                                {{ userInfo.memberLevel | memberLevelFilter }}<br>
                                到期：{{ userInfo.endTime.split(" ")[0] }}
                            </div>
                            <div class="vip-level-expired" v-if="userInfo.memberExpire == 2">
                                图片素材会员已过期
                                <span class="vip-level-btn" @click="toVip">开通会员</span>
                            </div>
                        </el-dropdown-item> -->
                        <el-dropdown-item command="work" class="list-menu"><span>我的主页</span></el-dropdown-item>
                        <!-- <el-dropdown-item command="experience">我的经验</el-dropdown-item> -->
                        <!-- <el-dropdown-item command="material">素材投稿</el-dropdown-item> -->
                        <el-dropdown-item command="collection" class="list-menu"><span>我的收藏</span></el-dropdown-item>
                        <!-- <el-dropdown-item command="draft">我的草稿</el-dropdown-item> -->
                        <el-dropdown-item command="sale" class="list-menu" v-if="userInfo.bindAuthorFlag"><span>销售数据</span></el-dropdown-item>
                        <el-dropdown-item command="paid" class="list-menu"><span>我的订单</span></el-dropdown-item>
                        <el-dropdown-item command="user" class="list-menu"><span>资料与账号</span></el-dropdown-item>
                        <!-- <el-dropdown-item command="myMaterial" v-if="userInfo.bindAuthorFlag">我的素材</el-dropdown-item> -->
                        <el-dropdown-item command="logout" class="list-menu"><span>退出登录</span></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="login-button" v-if="!userInfo">
                <router-link tag="span" :to="{ path: '/loginPage/login' }">登录/注册</router-link>
            </div>
        </div>

        <transition name="dialogFade">
            <login-dialog v-if="visible" :type="dialogType" @closeDialog="CloseDialog"></login-dialog>
        </transition>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getMessageList, readMessage } from '@/api/message';
import { getWorkSearchList, getSearchRecommend } from '@/api/search';
import { getUnRead, readPoint, getSearchDefaultKey } from '@/api/home';
import LoginDialog from './components/LoginDialog';
import EmptyPage from '@/components/EmptyPage';
import { _topicType } from '@/_constant';
import { bindEvent } from '@/utils/websocket';

export default {
    name: 'HeaderNav',
    components: {
        LoginDialog,
        EmptyPage,
    },
    inject: ['reload'],
    directives: {
        clickoutside: {
            bind(el, binding) {
                document.addEventListener('click', binding.value);
            },
            unbind(el, binding) {
                document.removeEventListener('click', binding.value);
            },
        },
    },
    data: () => ({
        topicTypes: [], // 发布类型列表
        noticeLoading: false,
        noticeList: [],
        uploadVisible: false,
        noticeVisible: false,
        userVisible: false,
        discoverVisible: false,
        avatarUrl: '/static/images/user.png',
        search: '',
        hasNewMessage: false,
        interval: null,
        inputFocus: false,
        tipList: [],
        searchKeyPlaceholder: '请输入关键词',
        searchKeyIndex: 0,
        searchDefaultKey: [
            //'世界地图' // 默认值，将通过API获取完整列表
        ],
        searchKeyTimer: null,
    }),
    computed: {
        ...mapState('user', ['userInfo']),
        ...mapState('login', ['visible', 'dialogType']),
        userId() {
            return (this.userInfo && this.userInfo.id) || null;
        },
    },
    watch: {
        userId(val) {
            if (val) {
                this.openNoticeLink(val);
                this.getUnreadMessageList(val);
            } else {
                this.closeNoticeLink();
            }
        },
    },
    filters: {
        memberLevelFilter(value) {
            const levelMap = {
                'F': '图片素材免费会员',
                'M': '图片素材月度会员',
                'Y': '图片素材年度会员',
                'TY': '图片素材三年会员',
            };
            return levelMap[value] || '免费会员';
        },
    },
    mounted() {
        this.topicTypes = _topicType;
        bindEvent('new_message', () => {
            this.hasNewMessage = true;
        });
        this.getUnRead();
        
        // 获取搜索关键词并启动轮播
        //this.getSearchKeywords();
    },
    beforeDestroy() {
        // 清除轮播定时器
        if (this.searchKeyTimer) {
            clearInterval(this.searchKeyTimer);
            this.searchKeyTimer = null;
        }
        
        // 清除消息通知定时器
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    },
    methods: {
        ...mapActions('user', ['LogOut']),
        ...mapActions('login', ['CloseDialog']),
        async getUnreadMessageList(id) {
            const { code, data } = await getMessageList({
                userid: id,
                pageSize: 5,
                pageNum: 1,
            });
            if (code === 0) {
                this.hasNewMessage = data.result.some((item) => item.status === 1);
            } else {
                this.hasNewMessage = false;
            }
        },
        async getUnRead() {
            const { code, data } = await getUnRead();
            this.tipList = data || [];
            // this.tipList = ['DESIGN_WORKS','EXPERIENCE','RESOURCES','MATERIAL','BUSINESS_PROJECT','COURSE']
        },
        toVip() {
			this.$router.push({ name: 'FindImageVip' });
		},
        clearSearchCache(path, modules) {
            sessionStorage.clear();
            this.readPoint(modules);
            this.$router.push({ path });
        },
        async readPoint(modules) {
            try {
                if (!this.tipList.includes(modules)) {
                    return;
                }
                await readPoint({ module: modules });
                this.getUnRead();
            } catch (error) {}
        },
        openNoticeLink(id) {
            if (!this.interval) {
                this.interval = window.setInterval(() => this.getUnreadMessageList(id), 1000 * 30);
                this.getUnreadMessageList(id);
            }
        },
        openProjectCase(){
            window.open("https://www.shuzixs.com/projectCase")
        },
        closeNoticeLink() {
            if (this.interval) {
                window.clearInterval(this.interval);
            }
        },
        async querySearch(queryString, cb) {
            if (queryString === '') {
                cb([]);
                return;
            }
            let params = {
                pageSize: 5,
                pageNum: 1,
                title: queryString,
            };
            const { code, data } = await getSearchRecommend(params);
            if (code === 0) {
                const list = data.map((item) => {
                    return {
                        value: item.keyword,
                        type: item.type
                    };
                });
                cb(list);
            } else {
                cb([]);
            }
        },
        clearSearch() {
            this.search = '';
        },
        handleSearch(item) {
            console.log('item: ', item);
            if(item.code ==="Enter" && this.search == '') {
                return
            }
            // 如果搜索框为空，使用当前轮播的关键词
            // const searchTerm = this.search.trim() || this.searchKeyPlaceholder;
            const searchTerm = this.search.trim();
            const routerMap = {
                'DESIGN_WORKS': 'Works',
                'EXPERIENCE': 'Experience',
                'SOURCE_CODE': 'SourceCode',
                'MATERIAL': 'FreeMaterial',
                'COURSE': 'Courses',
            }   
            const routerName = item && item.value ? routerMap[item.type] : this.$route.name;
            this.$router.push({
                name: 'Search',
                query: { 
                    search: searchTerm, 
                    routeName: routerName
                },
            });
            if (this.$route.name === 'Search') {
                this.reload();
            }
        },
        handleCommand(command) {
            switch (command) {
                case 'work':
                    this.$router.push({
                        name: 'User',
                        query: {
                            type: 0,
                        },
                    });
                    break;
                case 'experience':
                    this.$router.push({
                        name: 'User',
                        query: {
                            type: 1,
                        },
                    });
                    break;
                case 'draft':
                    this.$router.push({
                        name: 'User',
                        query: {
                            type: 6,
                        },
                    });
                    break;
                case 'paid':
                    this.$router.push({
                        name: 'User',
                        query: {
                            type: 7,
                        },
                    });
                    break;
                case 'material':
                    this.$router.push({
                        name: 'User',
                        query: {
                            type: 8,
                        },
                    });
                    break;
                case 'myMaterial':
                    this.$router.push({
                        name: 'User',
                        query: {
                            type: 9,
                        },
                    });
                    break;
                case 'user':
                    this.$router.push({ path: '/userInfo' });
                    break;
                case 'logout':
                    this.logout();
                    break;
                case 'collection':
                    this.$router.push({
                        name: 'User',
                        query: {
                            type: 2,
                        },
                    });
                    break;
                case 'sale':
                    this.$router.push({
                        name: 'Sale',
                    });
                    break;
                case 'imageVip':
                    this.$router.push({
                        name: 'FindImageVip',
                    });
                    break;
                default:
                    break;
            }
        },
        async handleNoticeDropdown(visible) {
            this.noticeVisible = visible;
            if (visible) {
                this.noticeLoading = true;
                try {
                    const params = {
                        userid: this.userInfo.id,
                        pageSize: 5,
                        pageNum: 1,
                    };
                    const { code, data } = await getMessageList(params);
                    if (code === 0) {
                        this.noticeList = data.result.map((item) => {
                            return {
                                id: item.id,
                                content: item.content,
                                noticetype: item.noticetype,
                                name: item.noticetype === 4 ? '' : item.frdName,
                            };
                        });
                        this.total = data.total;
                        this.pages = data.pages;
                        this.hasNewMessage = false;
                        if (data.result.some((item) => item.status === 1)) {
                            readMessage();
                        }
                    }
                } catch (e) {
                    throw e;
                } finally {
                    this.noticeLoading = false;
                }
            }
        },
        async logout() {
            this.LogOut().then(() => {
                this.reload();
            });
        },
        // 获取搜索关键词并启动轮播
        async getSearchKeywords() {
            try {
                const { code, data } = await getSearchDefaultKey();
                if (code === 0 && data && Array.isArray(data) && data.length > 0) {
                    this.searchDefaultKey = data;
                    this.searchKeyPlaceholder = this.searchDefaultKey[0];
                }
                // 启动搜索关键词轮播
                this.startSearchKeyRotation();
            } catch (error) {
                console.error('获取搜索关键词失败:', error);
                // 出错时仍启动轮播，使用默认值
                this.startSearchKeyRotation();
            }
        },
        // 启动搜索关键词轮播
        startSearchKeyRotation() {
            this.searchKeyTimer = setInterval(() => {
                this.searchKeyIndex = (this.searchKeyIndex + 1) % this.searchDefaultKey.length;
                this.searchKeyPlaceholder = this.searchDefaultKey[this.searchKeyIndex];
            }, 5000);
        },
    },
};
</script>

<style lang="scss">
.header-nav .search-input  {
    
    .el-input__inner {
        border-radius: 50px;
        background-color: #ECEFF8;
        border: none;
        color: #000;
        height: 36px;
        // cursor: pointer;
        border: 1px  solid #ECEFF8;
        box-sizing: border-box;
        line-height: 36px;
        &:hover {
            border: 1px solid #2F54EB;
            background: #fff;
        }
    }
    &:hover,&.search-active{
        .search-btn-icon{
            color:#2F54EB;
        }
        .el-input__inner {
            border: 1px solid #2F54EB;
            background: #fff;
        }
    }
}

.header-nav .search-input .el-input__inner::placeholder {
    color: #9398B0;
}
.header-nav .search-input .el-input__icon {
    line-height: 36px;
}
.header-nav .search-input .el-input__suffix {
    display: flex;
    align-items: center;
    right: 12px;
}
.header-nav .search-input .clear-icon {
    font-size: 20px;
    cursor: pointer;
    color: #9398B0;
    margin-right: 18px;
    font-weight: 600;
    &:hover {
        color: #666;
    }
}
.header-nav .search-input .search-btn-icon {
    font-size: 20px;
    cursor: pointer;
    color: #D8D8D8;
    font-weight: 600;
}
.notice {
    &::after {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        background: red;
        border-radius: 100%;
        position: relative;
        left: 3px;
        bottom: 13px;
    }
}
.dropdown-menu {
    .popper__arrow {
        display: none !important;
    }
    .self-item,
    .el-dropdown-menu__item {
        padding: 0 !important;
    }
    .list-menu span {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 9px 16px;
        display: inline-block;
    }
    & > {
        .el-dropdown-menu__item a {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 9px 16px;
            display: inline-block;
        }
    }
}
</style>

<style lang="scss" scoped>
.upload-dropdown {
    a {
        color: #333;
    }
}
.header-nav {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    height: 72px;

    &__logo {
        display: flex;
        align-items: center;
        cursor: pointer;
        .text-logo {
            width: 131px;
            height: 45px;
        }
        .icon-logo {
            width: 45px;
            height: 45px;
            margin-right: 10px;
        }
    }

    &__navigation {
        margin-left: 80px;
        flex: 1;
        user-select: none;

        &-list {
            display: flex;
            height: 72px;
            // .material span{
            //     font-weight: 600;
            // }

            li {
                display: flex;
                justify-content: center;
                margin: 4px 0;
                border-bottom: 2px solid transparent;
                // width: 70px;
                padding: 0 25px;
                height: 66px;
                cursor: pointer;
                position: relative;
                white-space: nowrap;

                span {
                    display: inline-block;
                    height: 58px;
                    line-height: 58px;
                    text-align: center;
                    @include font(rgba(251, 251, 251, 0.8), 16px, 400);
                    transition: all 0.3s;
                    &:hover {
                        color: #fff;
                    }
                }

                &:hover,
                &.active {
                    color: #fff;
                    // border-bottom: 2px solid #1FFFE1 ;
                }
            }
        }
    }

    &__auth {
        display: flex;
        align-items: center;
        margin-right: 22px;
        flex: 0 0 auto;
        justify-content: flex-end;

        &-item {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 64px;
            height: 72px;
            transition: all 0.3s;
            cursor: pointer;

            &:hover,
            &.active {
                background-color: rgba(255, 255, 255, 1);
                .icon-send,
                .icon-message,
                .icon-search {
                    color: #2f54eb;
                }
            }

            .el-dropdown-link {
                width: 64px;
                height: 72px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        &-search {
            margin-right: 20px;
            display: flex;
            align-items: center;

            .icon-search {
                color: #fff;
                font-size: 21px;
                cursor: pointer;
            }
            & /deep/ .el-autocomplete {
                width: 500px;
            }
        }
        
        .expanded-search {
            width: 500px;
            height: 36px;
        }

        .icon-send,
        .icon-message {
            color: #fff;
            font-size: 21px;
            transition: all 0.3s;
            &:hover {
                color: #2f54eb;
            }
        }
        .icon-user {
            position: relative;
            width: 30px;
            height: 30px;

            &-image {
                width: 30px;
                height: 30px;
                border-radius: 50%;
            }

            &-vip {
                position: absolute;
                top: -4px;
                right: -16px;

                .icon-avatar_vip {
                    color: #fff;
                    font-size: 16px;
                }
            }
        }

        .login-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 103px;
            height: 36px;
            background: #0027FF;
            border-radius: 50px 50px 50px 50px;
            color: #ECEEF8;
            font-size: 16px;
            font-weight: 400;
            cursor: pointer;
            &:hover {
                background: #597ef7;
            }
        }
    }
}

.dialogFade-enter-active,
.dialogFade-leave-active {
    transition: opacity 0.4s;
}

.dialogFade-enter,
.dialogFade-leave-active {
    opacity: 0;
}

.dropdown-menu {
    text-align: left;
    padding: 10px;
    background: #ffffff;
    box-shadow: 10px 10px 20px 0px rgba(39, 44, 64, 0.1);
    min-width: 160px;
    border-radius: 8px;
    .el-dropdown-menu__item {
        background: #fff;
        border-radius: 8px;
        padding: 9px 16px;
        font-size: 16px;
        margin-bottom: 10px;
        color: #272c40;
        line-height: unset !important;
        &:nth-last-child(1) {
            margin-bottom: 0;
        }
        &:hover {
            color: #fff;
            background: #2f54eb;
            a {
                color: #fff;
            }
        }
    }
    .vip-menu {
        border-bottom: 1px solid #ECEFF8;
        &:hover {
            background: inherit;
        }
    }
    .vip-level {
        font-size: 14px;
        color: #8C8C8C;
        cursor: pointer;
        padding:16px 16px 11px 16px;
        &:hover {
            color: #2f54eb;
        }
    }
    .vip-level-expired {
        font-size: 14px;
        color: #8C8C8C;
        padding:16px 16px 11px 16px;
        cursor: default;
        .vip-level-btn {
            color: #2f54eb;
            cursor: pointer;
            padding:0;
        }
    }
    span {
        display: block;
    }
}

.notice-wrapper {
    width: 260px;
    height: 300px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    padding: 0;
    overflow: hidden;

    &__title {
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(236, 236, 236, 1);
        @include font(rgba(39, 44, 64, 1), 14px, 600);
    }

    &__list {
        height: 200px;
        overflow: hidden;
        &-item {
            height: 50px;
            line-height: 50px;
            vertical-align: middle;
            padding: 0 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            transition: all 0.35s;
            box-sizing: border-box;
            cursor: pointer;
            @include font(rgba(145, 145, 145, 1), 14px, 600);

            &:not(:last-child) {
                border-bottom: 1px solid rgba(236, 236, 236, 1);
            }

            &:hover {
                background: rgba(238, 240, 248, 1);
                @include font(rgba(39, 44, 64, 1), 14px, 600);
            }

            .icon-noticeIcon {
                font-size: 16px;
            }
        }
    }
    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 260px;
        height: 200px;

        img {
            width: 180px;
        }

        span {
            margin-top: 10px;
            @include font(rgba(102, 105, 116, 1), 14px, 400);
        }
    }

    &__bottom {
        height: 50px;
        line-height: 50px;
        text-align: center;
        box-sizing: border-box;
        border-top: 1px solid rgba(236, 236, 236, 1);
        transition: background 0.35s;
        cursor: pointer;

        &:hover {
            background: rgba(238, 240, 248, 1);
        }

        span {
            @include font(rgba(39, 44, 64, 1), 14px, 600);
        }
    }
}
.svg-icon.icon-new {
    position: absolute;
    top: 3px;
    left: 60px;
    width: 2em;
}
.fade-enter-active,
.fade-leave-active {
    transition: all 0.15s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
@include mq($small) {
    .header-nav {
        & /deep/ .el-autocomplete {
            width: 300px;
        }
        
        .expanded-search, .header-nav__auth-search {
            width: 300px !important;
        }
    }
}
@include mq($smaller) {
    .header-nav {
        padding: 0 20px;
        & /deep/ .el-autocomplete {
            width: 300px;
        }
        
        .expanded-search, .header-nav__auth-search {
            width: 300px !important;
        }
    }
}
</style>
